module.exports = __webpack_public_path__ + "img/13.8de441e8.jpg";